import React from 'react';
import PropTypes from 'prop-types';
import useDeviceResize from '../../../../hooks/useDeviceResize';

const CustomListbox = React.forwardRef((props, ref) => {
  const isDeviceSmSize = useDeviceResize('sm');

  const { children, ...other } = props;
  return (
    <div
      ref={ref}
      {...other}
      style={{
        display: 'grid',
        gridTemplateColumns: isDeviceSmSize ? '1fr' : 'repeat(3, 1fr)',
        gap: '3px',
        width: '100%',
      }}
    >
      {React.Children.map(children, (child) => React.cloneElement(child, {
        style: {
          gridColumn: isDeviceSmSize ? 'span 3' : 'auto',
          padding: isDeviceSmSize ? '3rem .5rem' : '1rem .5rem',
          ...child.props.style,
        },
      }))}
    </div>
  );
});

CustomListbox.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomListbox;
